import Timeline from './timeline.vue';
export default Timeline;


// WEBPACK FOOTER //
// ./src/components/timeline/index.js